import React, { useMemo } from 'react';
import { DropdownItemProps } from '@kl/components-v6/src/dropdown/types';
import { resolveLanguageLocPath, landingSupportedLanguages } from '@next/shared';
import { LocalizedText } from 'shared/ui/localized-text';
import { useLocalizationContext } from 'shared/lib/localization';

export const useLocalesDropdown = () => {
    const {
        localizationService: { set },
    } = useLocalizationContext();

    return useMemo(() => {
        const createDropdownElement = (locale: string): DropdownItemProps => ({
            children: (
                <LocalizedText
                    key={locale}
                    localizationKey={resolveLanguageLocPath(locale)}
                    testId={locale}
                />
            ),
            componentsBefore: [<>&ensp;</>],
            onClick: () => set(locale),
        });

        return landingSupportedLanguages.map(value => createDropdownElement(value));
    }, []);
};
